export const TabletBreakpoint = 768;

export const MobileBreakpoint = 480;
